// composables/useScrollToComponent.js
import { useWebStore } from "~/store/web";

export function useScrollToComponent() {
  const store = useWebStore();

  function scrollToComponent(componentId) {
    var element = document.getElementById(componentId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: store.screenSize === 'mobile' ? 'start' : 'center'
      });
      element.classList.add('border-color-orange');
      setTimeout(function() {
        element.classList.remove('border-color-orange');
      }, 3000);
    } else {
      console.warn('Element with ID ' + componentId + ' not found.');
    }
  }

  return {
    scrollToComponent
  };
}
